import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Dropdown, Button, Segment, Grid, Divider,
  Form, Modal, Popup, Icon, Dimmer, Loader,
  Image, Header, Checkbox, Accordion
} from "semantic-ui-react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

var cursorCount = 0;
let selectedAddress = 0;

export class Oscilloscope extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isBACheckboxChecked: true,
      isAutomaticCheckboxChecked: true,
      isDimmerActive: false,

      oscilloscopeData: [],

      devices: [],
      wave: [],
      selectedDropdownAddress: -1,

      timeCursorValues: [],
      voltageCursorValues: [],
      cursorTimeUnit: Strings.MICROSSECOND,

      playButtonColor: "grey",
      pauseButtonColor: "grey",

      amplitudeActive: false,
      timeActive: false,

      series: [{ data: [] }],
      options: {
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true
          },
          x: {
            show: true,
            formatter: function (val) {
              return "Tempo: " + val.toFixed(2) + Strings.NANOSSECOND;
            },
          },
        },
        chart: {
          id: Constants.OSCILLOSCOPE_CHART_ID,
          type: "line",
          locales: [{
            "name": "pt-br",
            "options": {
              "months": [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro"
              ],
              "shortMonths": [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez"
              ],
              "days": [
                "Domingo",
                "Segunda",
                "Terça",
                "Quarta",
                "Quinta",
                "Sexta",
                "Sábado"
              ],
              "shortDays": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
              "toolbar": {
                "exportToSVG": "Baixar SVG",
                "exportToPNG": "Baixar PNG",
                "exportToCSV": "Baixar CSV",
                "menu": "Baixar",
                "selection": "Selecionar",
                "selectionZoom": "Selecionar Zoom",
                "zoomIn": "Aumentar",
                "zoomOut": "Diminuir",
                "pan": "Navegação",
                "reset": "Reiniciar Zoom"
              }
            }
          }],
          defaultLocale: "pt-br",
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: "reset",
            tools: {
              download: this.getDownloadImgPath(),
            }
          },
          animations: {
            enabled: false,
            easing: "linear",
            speed: 500,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
          events: {
            click: (event, chartContext, config) => {
              if (this.state.amplitudeActive) {
                this.addYAxisAnnotation(config.dataPointIndex, config.seriesIndex);
              }
              else if (this.state.timeActive) {
                this.addXAxisAnnotation(config.dataPointIndex);
              }
            },
            scrolled: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false
                });

                this.clearAllAnnotations();
              }
            },
            selection: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false
                });

                this.clearAllAnnotations();
              }
            },
            zoomed: () => {
              if (this.state.amplitudeActive || this.state.timeActive) {
                this.setState({
                  amplitudeActive: false,
                  timeActive: false
                });

                this.clearAllAnnotations();
              }
            }
          }
        },
        colors: [Constants.PURPLE_HEX],
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight",
          width: 2
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS
          },
          crosshairs: {
            show: "true"
          },
          tooltip: {
            enabled: false
          },
          labels: {
            show: true,
            formatter: function (value) {
              if (value !== undefined && value < 10) {
                return value.toFixed(2);
              }
              else if (value !== undefined && value >= 10) {
                return value.toFixed(0);
              }
              else {
                return value;
              }
            }
          }
        },
        yaxis: {
          min: -8,
          max: 8,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + " V";
            },
          },
          title: {
            text: Strings.VOLTAGE_V
          },
        },
        annotations: {
          position: "front",
          xaxis: []
        }
      },

      errorMessages: []
    };
  }

  getDownloadImgPath = () => {
    return `<img src="${process.env.PUBLIC_URL}/images/down-arrow.svg" height="18" style="margin-left: 5px;" />`;
  }

  retrieveData = () => {
    this.setDimmerActiveState(true);
    // Get livelist data
    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data =>
        this.setState({
          devices: data.sort(UtilsInstance.sortBy(
            "address",
            false,
            parseInt))
        }, () => {
          this.startAutoVisualization();
        }));
  }

  formatWaveTimes = (wave) => {
    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds 
      // (it already is by default, so do nothing here)
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / (10 ** 3);
      }
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / (10 ** 6);
      }
    }

    return wave;
  }

  getFormatedOptions = (wave, deviceAddress) => {
    let options = {};

    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds
      options = {
        ...this.state.options,
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true
          },
          x: {
            show: true,
            formatter: function (val) {
              return "Tempo: " + val.toFixed(2) + Strings.NANOSSECOND;
            },
          },
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS
          },
          crosshairs: {
            show: "true"
          },
          tooltip: {
            enabled: false
          }
        },
        title: {
          text: "Endereço: " + deviceAddress,
          align: "center"
        }
      };

      this.setState({ cursorTimeUnit: Strings.NANOSSECOND });

    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      options = {
        ...this.state.options,
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true
          },
          x: {
            show: true,
            formatter: function (val) {
              return "Tempo: " + val.toFixed(2) + Strings.MICROSSECOND;
            },
          },
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_US
          },
          crosshairs: {
            show: "true"
          },
          tooltip: {
            enabled: false
          }
        },
        title: {
          text: "Endereço: " + deviceAddress,
          align: "center"
        }
      };

      this.setState({ cursorTimeUnit: Strings.MICROSSECOND });

    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      options = {
        ...this.state.options,
        tooltip: {
          enabled: true,
          intersect: false,
          shared: false,
          onDatasetHover: {
            highlightDataSeries: true
          },
          x: {
            show: true,
            formatter: function (val) {
              return "Tempo: " + val.toFixed(2) + Strings.MILLISSECOND;
            },
          },
        },
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_MS
          },
          crosshairs: {
            show: "true"
          },
          tooltip: {
            enabled: false
          }
        },
        title: {
          text: "Endereço: " + deviceAddress,
          align: "center"
        }
      };

      this.setState({ cursorTimeUnit: Strings.MILLISSECOND });

    }

    if (this.state.isBACheckboxChecked) {
      options.colors = [Constants.PURPLE_HEX];
    }
    else {
      options.colors = [Constants.GREEN_HEX, Constants.RED_HEX];
    }

    if (this.state.isAutomaticCheckboxChecked) {
      options.chart.toolbar = {
        show: false,
        autoSelected: "reset",
        tools: {
          download: this.getDownloadImgPath(),
        }
      };
    }
    else {
      options.chart.toolbar = {
        show: true,
        autoSelected: "reset",
        tools: {
          download: this.getDownloadImgPath(),
        }
      };
    }

    options.markers = {
      size: 1,
      colors: "#000",
      strokeColors: "#000",
      discrete: [{
        seriesIndex: 0,
        dataPointIndex: this.state.oscilloscopeData[0].pontoDiferente,
        fillColor: "#000",
        strokeColor: "#000",
        size: 10,
        shape: "circle" // "circle" | "square" | "rect"
      }]
    };

    return options;
  }

  getSizeImage = () => {
    return <Image src={`${process.env.PUBLIC_URL}/images/size_desc_img.png`} />;
  }

  // --------------- Dropdown Methods -------------------------------
  buildDevicesDropdownOptions = (devices) => {
    let dropdownMap = devices.map(device => (
      {
        key: device.address,
        text: Strings.ADDRESS_DP + device.address,
        value: device.address
      }
    ));

    return dropdownMap;
  }

  onDevicesDropdownChange = (e, { value }) => {
    this.setState({
      selectedDropdownAddress: value,
      playButtonColor: "grey",
      pauseButtonColor: "red"
    }, () => {
      clearInterval(this.state.intervalID);

      // Verify first which type of chart is selected
      if (this.state.isBACheckboxChecked) {
        this.getBADeviceWaveData(this.state.selectedDropdownAddress);
      }
      else {
        this.getABDeviceWaveData(this.state.selectedDropdownAddress);
      }

      this.clearAllAnnotations();
      this.setDisabledButtonsState(false, false, false, false);
    });
  }

  // ---------------- Get the wave data of the choosen device ----------------
  getBADeviceWaveData = async (deviceAddress) => {
    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "oscilloscopeWave3byte/" + deviceAddress, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ oscilloscopeData: data }, () => {
        if (this.state.oscilloscopeData[0] !== undefined) {
          // Onlyu change the wave if the update flag is true
          //if (this.state.oscilloscopeData[0].update) {
          //console.log("Update: true");
          this.setState({
            options: this.getFormatedOptions(this.state.oscilloscopeData[0].wave, deviceAddress),
            series: [{
              name: Strings.WAVE_B_A,
              data: this.formatWaveTimes(this.state.oscilloscopeData[0].wave)
            }]
          });
          //}
          //else {
          //  console.log("Update: false");
          //}
        }
        // If data for this deviceAddress doesn't exist, set the data as an empty array
        else {
          this.setState({ series: [{ name: Strings.WAVE_B_A, data: [] }] });
        }
      }));
  }

  getABDeviceWaveData = async (deviceAddress) => {
    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "oscilloscopeWaveAB3byte/" + deviceAddress, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ oscilloscopeData: data }, () => {
        if (this.state.oscilloscopeData[0] !== undefined) {
          // Onlyu change the wave if the update flag is true
          //if (this.state.oscilloscopeData[0].update) {
          //console.log("Update: true");
          this.setState({
            options: this.getFormatedOptions(this.state.oscilloscopeData[0].waveA, deviceAddress),
            series: [
              {
                name: Strings.WAVE_A,
                data: this.formatWaveTimes(this.state.oscilloscopeData[0].waveA)
              },
              {
                name: Strings.WAVE_B,
                data: this.formatWaveTimes(this.state.oscilloscopeData[0].waveB)
              }
            ]
          });
          //}
          //else {
          //  console.log("Update: false");
          //}
        }
        // If data for this deviceAddress doesn't exist, set the data as an empty array
        else {
          this.setState({
            series: [
              { name: Strings.WAVE_A, data: [] },
              { name: Strings.WAVE_B, data: [] }
            ]
          });
        }
      }));
  }

  // ---------------------- Control Buttons ----------------------
  handlePlayButtonClick = () => {
    if (this.state.playButtonColor !== "green") {
      let intervalID = -1;

      // First clear all annotations
      this.clearAllAnnotations();

      // Verify which checkbox is marked and get the appropriate device's wave data
      if (this.state.isBACheckboxChecked) {
        this.getBADeviceWaveData(this.state.selectedDropdownAddress);
        // Then set for the data to be refreshed every 5 seconds
        intervalID = setInterval(() => { this.getBADeviceWaveData(this.state.selectedDropdownAddress); }, Constants.PLAY_REFRESH_INTERVAL_MS);
      }
      else {
        this.getABDeviceWaveData(this.state.selectedDropdownAddress);
        // Then set for the data to be refreshed every 5 seconds
        intervalID = setInterval(() => { this.getABDeviceWaveData(this.state.selectedDropdownAddress); }, Constants.PLAY_REFRESH_INTERVAL_MS);
      }

      // And change the color of the buttons
      this.setDisabledButtonsState(false, false, true, true);

      this.setState({
        intervalID: intervalID,
        playButtonColor: "green",
        pauseButtonColor: "grey"
      });
    }
  }

  handlePauseButtonClick = () => {
    // Stop the data refresh
    clearInterval(this.state.intervalID);

    this.setDisabledButtonsState(false, false, false, false);

    this.setState({
      playButtonColor: "grey",
      pauseButtonColor: "red"
    });
  }

  // ---------------------- Cursor Buttons  ----------------------
  handleAmplitudeButtonClick = () => {
    this.setState({
      amplitudeActive: !this.state.amplitudeActive,
      timeActive: false
    });

    this.clearAllAnnotations();
  }

  handleTimeButtonClick = () => {
    this.setState({
      timeActive: !this.state.timeActive,
      amplitudeActive: false
    });

    this.clearAllAnnotations();
  }

  // ---------------------- Button States ----------------------
  setDisabledButtonsState = (playState, pauseState, amplitudeState, timeState) => {
    document.getElementById("play-btn").disabled = playState;
    document.getElementById("pause-btn").disabled = pauseState;
    document.getElementById("amplitude-btn").disabled = amplitudeState;
    document.getElementById("time-interval-btn").disabled = timeState;
  }

  // --------------- Cursors Methods -------------------------------
  clearAllAnnotations = () => {
    // Ask ApexCharts to clear the cursors from screen
    ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

    // Reset the cursors values arrays
    this.setState({
      timeCursorValues: [],
      voltageCursorValues: []
    });

    // Set the cursors calculation texts back to default
    document.getElementById("time-interval").innerText = Strings.TIME_INTERVAL_PLACEHOLDER + this.state.cursorTimeUnit;
    document.getElementById("wave-amplitude").innerText = Strings.AMPLITUDE_PLACEHOLDER;

    // Finally reset the number of active cursors back to 0
    cursorCount = 0;
  }

  addXAxisAnnotation = (dataPointIndex) => {
    // Only let the user set time cursors if the button is enabled
    if (!document.getElementById("time-interval-btn").disabled) {
      let timeCursorValuesCopy = this.state.timeCursorValues;

      // If the user has clicked on the first point, draw the cursor there
      if (dataPointIndex !== -1 && cursorCount === 0) {
        timeCursorValuesCopy.push(this.state.series[0].data[dataPointIndex][0]);

        this.setState({ timeCursorValues: timeCursorValuesCopy }, () => {

          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "addXaxisAnnotation", {
            x: this.state.timeCursorValues[0],
            strokeDashArray: 0,
            borderColor: Constants.TEAL_HEX
          });

          cursorCount++;

        });
      }
      // If it is the second point draw a range cursor
      else if (dataPointIndex !== -1 && cursorCount === 1) {
        ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

        timeCursorValuesCopy.push(this.state.series[0].data[dataPointIndex][0]);

        this.setState({ timeCursorValues: timeCursorValuesCopy }, () => {

          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "addXaxisAnnotation", {
            x: this.state.timeCursorValues[0],
            x2: this.state.timeCursorValues[1],
            strokeDashArray: 0,
            fillColor: Constants.TEAL_HEX,
            opacity: 0.4,
            borderColor: Constants.TEAL_HEX
          });

          let timeInterval = Math.abs(this.state.timeCursorValues[0] - this.state.timeCursorValues[1]);
          document.getElementById("time-interval").innerText = timeInterval.toFixed(2) + this.state.cursorTimeUnit;

          cursorCount++;
        });
      }
      // If the user clicks on a dataPoint for a third time, clear the cursors
      else if (dataPointIndex !== -1 && cursorCount === 2) {
        this.clearAllAnnotations();
      }
    }
  }

  addYAxisAnnotation = (dataPointIndex, seriesIndex) => {
    // Only let the user set amplitude cursors if the button is enabled
    if (!document.getElementById("amplitude-btn").disabled) {
      let voltageCursorValuesCopy = this.state.voltageCursorValues;

      // If the user has clicked on the first point, draw the cursor there
      if (dataPointIndex !== -1 && cursorCount === 0) {
        voltageCursorValuesCopy.push(this.state.series[seriesIndex].data[dataPointIndex][1]);

        this.setState({ voltageCursorValues: voltageCursorValuesCopy }, () => {

          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "addYaxisAnnotation", {
            y: this.state.voltageCursorValues[0],
            yAxisIndex: 0,
            strokeDashArray: 0,
            borderColor: Constants.TEAL_HEX
          });
        });

        cursorCount++;

      }
      // If it is the second point draw a range cursor
      else if (dataPointIndex !== -1 && cursorCount === 1) {
        ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "clearAnnotations");

        voltageCursorValuesCopy.push(this.state.series[seriesIndex].data[dataPointIndex][1]);

        this.setState({ voltageCursorValues: voltageCursorValuesCopy }, () => {

          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "addYaxisAnnotation", {
            y: this.state.voltageCursorValues[0],
            y2: this.state.voltageCursorValues[1],
            strokeDashArray: 0,
            fillColor: Constants.TEAL_HEX,
            opacity: 0.4,
            borderColor: Constants.TEAL_HEX
          });

          let amplitude = Math.abs(this.state.voltageCursorValues[0] - this.state.voltageCursorValues[1]);
          document.getElementById("wave-amplitude").innerText = amplitude.toFixed(2) + Strings.VOLTAGE;

          cursorCount++;
        });
      }
      // If the user clicks on a dataPoint for a third time, clear the cursors
      else if (cursorCount === 2) {
        this.clearAllAnnotations();
      }
    }
  }

  setDimmerActiveState = (state) => {
    this.setState({ isDimmerActive: state });
  }

  /// ---------------- Visualization Type -----------------------------
  handleVisualizationTypeCheckboxChange = (e, { value }) => {
    this.setState({ isAutomaticCheckboxChecked: (value === Constants.AUTOMATIC_CHECKBOX_VAL) }, () => {

      clearInterval(this.state.intervalID);

      if (this.state.isAutomaticCheckboxChecked) {
        this.setState({ selectedDropdownAddress: -1 });
        this.setDisabledButtonsState(true, true, true, true);
        this.startAutoVisualization();
        document.getElementById("devices-dropdown").style.display = "none";
      }
      else {
        document.getElementById("devices-dropdown").style.display = "block";
        clearInterval(this.state.autoVisualizationIntervalID);
        selectedAddress = 0;
        this.setState({
          series: [{ data: [] }],
          options: {
            ...this.state.options,
            title: {
              text: "",
              align: "center"
            }
          }
        });
      }
    });
  }

  startAutoVisualization = () => {
    this.clearAllAnnotations();
    // Every 2 seconds start cycling through all the devices
    let autoVisualizationIntervalID = setInterval(() => {

      this.setDimmerActiveState(false);

      if (this.state.isBACheckboxChecked) {
        if (this.state.devices.length > 0) {
          this.getBADeviceWaveData(this.state.devices[selectedAddress].address);
        }
      }
      else {
        if (this.state.devices.length > 0) {
          this.getABDeviceWaveData(this.state.devices[selectedAddress].address);
        }
      }

      if (selectedAddress === (this.state.devices.length - 1)) {
        selectedAddress = 0;
      }
      else {
        selectedAddress++;
      }

    }, Constants.AUTO_VISUALIZATION_REFRESH_MS);

    // Save the interval ID as a state so it is possible to cancel it later
    this.setState({ autoVisualizationIntervalID: autoVisualizationIntervalID });
  }

  getReferenceImagesModal = () => {
    return (
      <Modal basic style={modalStyle} trigger={<Button circular icon="info" color="teal" />}>
        <Modal.Header style={modalHeaderStyle}>{Strings.MODAL_TITLE}</Modal.Header>
        <Modal.Content>
          <Grid columns="equal" centered>
            <Grid.Row>
              <Grid.Column textAlign="center" stretched>
                <Segment>
                  <Header as="h3" dividing>{Strings.STD_WAVE_FORM}</Header>
                  <Image src={`${process.env.PUBLIC_URL}/images/forma-padrao.png`} />
                </Segment>
              </Grid.Column>
              <Grid.Column textAlign="center" stretched>
                <Segment>
                  <Header as="h3" dividing>{Strings.LONG_CABLE_WAVE_FORM}</Header>
                  <Image src={`${process.env.PUBLIC_URL}/images/cabo-longo.png`} />
                </Segment>
              </Grid.Column>
              <Grid.Column textAlign="center" stretched>
                <Segment>
                  <Header as="h3" dividing>{Strings.EXCESS_TERMINATIOR_WAVE_FORM}</Header>
                  <Image src={`${process.env.PUBLIC_URL}/images/excesso-terminador.png`} />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column textAlign="center" stretched>
                <Segment>
                  <Header as="h3" dividing>{Strings.NO_SLAVE_WAVE_FORM}</Header>
                  <Image src={`${process.env.PUBLIC_URL}/images/ausencia-escravo.png`} />
                </Segment>
              </Grid.Column>
              <Grid.Column textAlign="center" stretched>
                <Segment>
                  <Header as="h3" dividing>{Strings.REFLECTION_WAVE_FORM}</Header>
                  <Image src={`${process.env.PUBLIC_URL}/images/reflexao.png`} />
                </Segment>
              </Grid.Column>
              <Grid.Column textAlign="center" stretched>
                <Segment>
                  <Header as="h3" dividing>{Strings.NO_TERMINATOR_WAVE_FORM}</Header>
                  <Image src={`${process.env.PUBLIC_URL}/images/falta-terminador.png`} />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <p style={moreInfoTextStyle}>{Strings.FOR_MORE_INFO_DP}</p>
          </Grid>

        </Modal.Content>
      </Modal>
    );


  }

  /// ---------------- Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  /// ---------------- Chart Type Checkbox -----------------------------
  handleChartTypeCheckboxChange = (e, { value }) => {
    this.setState({ isBACheckboxChecked: (value === Constants.BA_CHECKBOX_VAL) }, () => {

      // If the user has already selected one address in the dropdown,
      if (this.state.selectedDropdownAddress !== -1) {

        this.setState({
          playButtonColor: "grey",
          pauseButtonColor: "red"
        }, () => {
          // Stop the refresh timer if it is on
          clearInterval(this.state.intervalID);

          // Check which type of chart is selected
          if (this.state.isBACheckboxChecked) {

            // Clear the chart before drawing again
            this.setState({ series: [{ name: "", data: [] }] }, () => {

              // Change the colors of the chart to purple 
              ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "updateOptions", {
                colors: [Constants.PURPLE_HEX]
              }, false, true);

              // And show the B - A Chart
              this.getBADeviceWaveData(this.state.selectedDropdownAddress);
            });
          }
          else {

            // Clear the chart before drawing again
            this.setState({ series: [{ name: "", data: [] }] }, () => {

              // Change the colors of the chart to red and green 
              ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "updateOptions", {
                colors: [Constants.GREEN_HEX, Constants.RED_HEX]
              }, false, true);

              // And show the A and B Chart
              this.getABDeviceWaveData(this.state.selectedDropdownAddress);
            });
          }

          // Regardless of the chart type that was chosen, clear annotations
          // And reset button states
          this.clearAllAnnotations();
          this.setDisabledButtonsState(false, false, false, false);
        });

      }
      // If no address is selected, just change the colors of the chart
      else {
        if (this.state.isBACheckboxChecked) {
          // Change the colors of the chart to purple 
          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "updateOptions", {
            colors: [Constants.PURPLE_HEX]
          }, false, true);
        }
        else {
          // Change the colors of the chart to red and green 
          ApexCharts.exec(Constants.OSCILLOSCOPE_CHART_ID, "updateOptions", {
            colors: [Constants.GREEN_HEX, Constants.RED_HEX]
          }, false, true);
        }
      }
    });
  }

  /// ---------------- Error Messages -----------------------------
  retrieveWarnings = () => {
    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "warnings", { mode: "cors" })
      .then(res => res.json())
      .then(data => {
        this.handleWarningMessages(data);
      });
  }

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (errors.InitPicoNotFound || errors.invertedAB || errors.picoNotFound || errors.monitorIPNotFound) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "block";
      }

      if (errors.InitPicoNotFound) {
        errorMessages.push(Strings.INIT_PICO_NOT_FOUND);
      }

      if (errors.invertedAB) {
        errorMessages.push(Strings.INVERTED_AB);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.monitorIPNotFound) {
        errorMessages.push(Strings.MONITOR_IP_NOT_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    }
    else {

      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "none";
      }

      this.setState({ errorMessages: [] });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    selectedAddress = 0;
    this.retrieveData();
    this.retrieveWarnings();
    this.setState({ warningsIntervalID: setInterval(this.retrieveWarnings, 1000) });
    this.setDisabledButtonsState(true, true, true, true);
  }

  componentWillUnmount() {
    clearInterval(this.state.warningsIntervalID);
    clearInterval(this.state.autoVisualizationIntervalID);
  }

  render() {
    let dropdownOptions = this.buildDevicesDropdownOptions(this.state.devices);

    return (
      <div style={screenStyle}>

        <Grid columns={2} doubling>
          <Grid.Row>

            <Grid.Column width={4}>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.WAVE_FORM}</Divider>
                <Form style={formStyle}>
                  <Form.Field>
                    <Checkbox
                      radio
                      label={Strings.B_A}
                      checked={this.state.isBACheckboxChecked}
                      value={Constants.BA_CHECKBOX_VAL}
                      onChange={this.handleChartTypeCheckboxChange} />
                  </Form.Field>

                  <Form.Field style={formFieldStye}>
                    <Checkbox
                      radio
                      label={Strings.A_AND_B}
                      checked={!this.state.isBACheckboxChecked}
                      value={Constants.AB_CHECKBOX_VAL}
                      onChange={this.handleChartTypeCheckboxChange} />
                  </Form.Field>
                </Form>
              </Segment>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.VISUALIZATION}</Divider>
                <Form style={formStyle}>
                  <Form.Group widths="equal">
                    <Form.Checkbox
                      radio
                      label={Strings.AUTOMATIC}
                      checked={this.state.isAutomaticCheckboxChecked}
                      value={Constants.AUTOMATIC_CHECKBOX_VAL}
                      onChange={this.handleVisualizationTypeCheckboxChange} />

                    <Form.Checkbox
                      radio
                      label={Strings.MANUAL}
                      checked={!this.state.isAutomaticCheckboxChecked}
                      value={Constants.MANUAL_CHECKBOX_VAL}
                      onChange={this.handleVisualizationTypeCheckboxChange} />
                  </Form.Group>
                </Form>

                <Dropdown
                  id="devices-dropdown"
                  style={dropdownStyle}
                  placeholder="Dispositivos"
                  fluid
                  selection
                  scrolling
                  options={dropdownOptions}
                  onChange={this.onDevicesDropdownChange} />
              </Segment>

              <Segment>

                <Divider horizontal style={dividerStyle}>
                  {Strings.CONTROLS}
                  <Popup position='bottom center' hoverable pinned
                    trigger={<Icon name="info circle" color="teal" />}>
                    <Popup.Content style={{ paddingLeft: "1vw" }}>
                      <li><b>Obs 1:</b> {Strings.CONTROLS_POPUP_TEXT_2}</li>
                      <li><b>Obs 2:</b> {Strings.CONTROLS_POPUP_TEXT}</li>
                    </Popup.Content>
                  </Popup >
                </Divider>

                <Button.Group size="large" style={controlsButtonGroupStyle}>
                  <Button
                    id="play-btn"
                    onClick={this.handlePlayButtonClick}
                    icon="play"
                    color={this.state.playButtonColor} />

                  <Button
                    id="pause-btn"
                    onClick={this.handlePauseButtonClick}
                    icon="pause"
                    color={this.state.pauseButtonColor} />

                </Button.Group>
              </Segment>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.CURSORS}</Divider>
                <Grid columns="2" centered verticalAlign="middle" celled style={cursorsGridStyle}>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        id="amplitude-btn"
                        toggle
                        active={this.state.amplitudeActive}
                        onClick={this.handleAmplitudeButtonClick}
                        color="teal"
                        fluid>
                        {Strings.AMPLITUDE}
                      </Button>
                    </Grid.Column>
                    <Grid.Column textAlign="center" stretched>
                      <p id="wave-amplitude" style={cursorValuesStyle}>{Strings.AMPLITUDE_PLACEHOLDER}</p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        id="time-interval-btn"
                        toggle
                        active={this.state.timeActive}
                        onClick={this.handleTimeButtonClick}
                        color="teal"
                        fluid>
                        &Delta;{Strings.TIME_INTERVAL}
                      </Button>
                    </Grid.Column>
                    <Grid.Column textAlign="center" stretched>
                      <p id="time-interval" style={cursorValuesStyle}>{Strings.TIME_INTERVAL_PLACEHOLDER}</p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>

              <Accordion id="message-list" styled style={accordionStyle}>
                <Accordion.Title
                  style={accordionTitleStyle}
                  active={this.state.accordionIndex === 1}
                  index={1}
                  onClick={this.handleAccordionClick}
                >
                  <Icon name="exclamation triangle" />
                  {Strings.DETECTED_PROBLEMS}
                  <Icon name="dropdown" />
                </Accordion.Title>
                <Accordion.Content active={this.state.accordionIndex === 1}>
                  <div style={accordionListItemsStyle}>
                    <ul style={{ paddingLeft: 0 }}>
                      {this.state.errorMessages.map((message) => (
                        <li key={message}>{message}</li>
                      ))}
                    </ul>
                  </div>
                </Accordion.Content>
              </Accordion>

            </Grid.Column>

            <Grid.Column width={12}>
              <Segment textAlign="right">

                {this.getReferenceImagesModal()}

                <Chart
                  options={this.state.options}
                  series={this.state.series}
                  type="line"
                  height={UtilsInstance.adjustChartHeight()} />

                <Dimmer active={this.state.isDimmerActive}>
                  <Loader>{Strings.LOADING}</Loader>
                </Dimmer>
              </Segment>

            </Grid.Column>

          </Grid.Row>
        </Grid>

      </div >
    );
  }
}

const formStyle = {
  marginTop: "-8pt",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "-10pt"
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

const screenStyle = {
  marginTop: "4vh",
  marginRight: "2vw",
  marginLeft: "2vw",
  textAlign: "center",
};

const dropdownStyle = {
  display: "none",
  marginBottom: "2vh",
  marginLeft: "auto",
  marginRight: "auto"
};

const cursorValuesStyle = {
  fontSize: "1.1em"
};

const modalStyle = {
  overflowY: "scroll"
};

const modalHeaderStyle = {
  textAlign: "center"
};

const moreInfoTextStyle = {
  margin: "2vh 2vw",
  fontSize: "1.2em"
};

const formFieldStye = {
  marginTop: "-24px"
};

const controlsButtonGroupStyle = {
  marginTop: "-4pt",
  marginBottom: "-4pt"
};

const cursorsGridStyle = {
  marginTop: "-5pt",
  marginBottom: "-4pt"
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

export default withRouter(Oscilloscope);
